import {Header} from "../components/Header";
import {Group} from '@mantine/core';
import {ConfigTextSection} from "../components/ConfigTextSection";
import {ConfigNav} from "../components/ConfigNav";
import {TableOfContents} from "../components/TableOfContents";

const ConfigPage = () => {

    return (
        <>
            <Header/>
            <Group style={{
                display: 'flex',
                position: 'relative',
                justifyContent: 'space-between'
            }}
                   align="flex-start"
                   justify="flex-start"
            >
                <TableOfContents/>
                <ConfigTextSection/>
                <ConfigNav/>
            </Group>
        </>
    )
}

export default ConfigPage;